import {Box, Modal} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../app/store/hooks";
import {setFullscreenPreview, setPopUpOpen} from "../app/store/slices/appSlice";
import {GenerationStatusEnum} from "../shared/types/GenerationStatusEnum";
import {FullscreenGeneratedContent} from "../shared/ui/FullscreenGeneratedContent";
import {FullscreenProcessingContent} from "../shared/ui/FullscreenProcessingContent";
import {FullscreenFailedContent} from "../shared/ui/FullscreenFailedContent";
import {GenerationApi} from "../entities/api/generationApi.ts";
import {useMemo} from "react";


export const FullscreenPreview = () => {
    const dispatch = useAppDispatch();
    const fullscreenPreview = useAppSelector((state) => state.app.fullscreenPreview)
    const generationApi = useMemo(() => new GenerationApi(), []);

    const handleClose = () => {
        dispatch(setFullscreenPreview(null));
    };

    const handeleDownload = async () => {
        if (!fullscreenPreview) return;
        await generationApi.downloadGeneration(fullscreenPreview.id);
        dispatch(setFullscreenPreview(null));
        dispatch(setPopUpOpen({isOpen: true, message: 'Media has been sent to your telegram'}));
    }

    const renderContent = () => {
        if (!fullscreenPreview) return null;

        switch (fullscreenPreview.status) {
            case GenerationStatusEnum.GENERATED:
                return fullscreenPreview.resultSrc ? (
                    <FullscreenGeneratedContent src={fullscreenPreview.resultSrc} onClose={handleClose} type={fullscreenPreview.type || 'image'} onDownLoad={handeleDownload} />
                ) : null;

            case GenerationStatusEnum.PROCESSING:
                return <FullscreenProcessingContent onClose={handleClose} />;

            case GenerationStatusEnum.FAILED:
                return <FullscreenFailedContent onClose={handleClose} />;
        }
    };

    return (
        <Modal
            open={!!fullscreenPreview}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    outline: 'none',
                }}
            >
                {renderContent()}
            </Box>
        </Modal>
    );
};
